var _slicedToArray = require("/zeit/253ce11f/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.for-each");

var _toConsumableArray = require("/zeit/253ce11f/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.array.map");

// Utilities
var lowerCase = require('./lower-case');

var specials = require('./specials');

var regex = /(?:(?:(\s?(?:^|[.\(\)!?;:"-])\s*)(\w))|(\w))(\w*[’']*\w*)/g;

var convertToRegExp = function convertToRegExp(specials) {
  return specials.map(function (s) {
    return [new RegExp("\\b".concat(s, "\\b"), 'gi'), s];
  });
};

function parseMatch(match) {
  var firstCharacter = match[0]; // test first character

  if (/\s/.test(firstCharacter)) {
    // if whitespace - trim and return
    return match.substr(1);
  }

  if (/[\(\)]/.test(firstCharacter)) {
    // if parens - this shouldn't be replaced
    return null;
  }

  return match;
}

module.exports = function (str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  str = str.toLowerCase().replace(regex, function (m) {
    var lead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var forced = arguments.length > 2 ? arguments[2] : undefined;
    var lower = arguments.length > 3 ? arguments[3] : undefined;
    var rest = arguments.length > 4 ? arguments[4] : undefined;
    var parsedMatch = parseMatch(m);

    if (!parsedMatch) {
      return m;
    }

    if (!forced) {
      var fullLower = lower + rest;

      if (lowerCase.has(fullLower)) {
        return parsedMatch;
      }
    }

    return lead + (lower || forced).toUpperCase() + rest;
  });
  var customSpecials = options.special || [];
  var replace = [].concat(_toConsumableArray(specials), _toConsumableArray(customSpecials));
  var replaceRegExp = convertToRegExp(replace);
  replaceRegExp.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        pattern = _ref2[0],
        s = _ref2[1];

    str = str.replace(pattern, s);
  });
  return str;
};